module.exports = function() {
  return new Worker(__webpack_public_path__ + "a5449aed449ed80c0d12.worker.js");
};